import { render } from "./Latest.vue?vue&type=template&id=31d06c0a&scoped=true&ts=true"
import script from "./Latest.vue?vue&type=script&lang=ts"
export * from "./Latest.vue?vue&type=script&lang=ts"

import "./Latest.vue?vue&type=style&index=0&id=31d06c0a&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31d06c0a"]])

export default __exports__